'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["listStyleReset"];
import React from 'react';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { rootStyle } from "../../styles/index.mjs";
import styled, { css } from "../../styled-components.mjs";
var TypeListElement = styled.ul.attrs(function (props) {
  return {
    role: props.role || 'list',
    listStyleReset: props.listStyleReset || false
  };
}).withConfig({
  displayName: "TypeList__TypeListElement",
  componentId: "sc-1jhixr6-0"
})(["", ";padding-inline-start:", ";padding-inline-end:0;padding-block-end:", ";margin-block-start:0;margin-block-end:0;overflow-wrap:break-word;", ";"], rootStyle(), function (props) {
  return props.condensedAll ? '0' : '32px';
}, function (props) {
  return props.condensed && '0';
}, function (props) {
  return props.listStyleReset !== false && css(["list-style-type:none;"]);
});
var typeListHelpers = {
  ul: styled(TypeListElement).attrs({
    as: 'ul'
  }).withConfig({
    displayName: "TypeList__ul",
    componentId: "sc-1jhixr6-1"
  })([""]),
  ol: styled(TypeListElement).attrs({
    as: 'ol'
  }).withConfig({
    displayName: "TypeList__ol",
    componentId: "sc-1jhixr6-2"
  })([""])
};
var TypeListComponent = /*#__PURE__*/React.forwardRef(function TypeList(_ref, ref) {
  var _ref$listStyleReset = _ref.listStyleReset,
    listStyleReset = _ref$listStyleReset === void 0 ? false : _ref$listStyleReset,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(TypeListElement, Object.assign({}, props, {
    ref: ref,
    listStyleReset: listStyleReset,
    "data-encore-id": ENCORE_DATA_IDS.TypeList
  }));
});
export var TypeList = Object.assign(TypeListComponent, typeListHelpers);